import { Admin } from './admin';
import { GroupWaveSharedSingle }           from './group-wave-shared-single';

export class WaveSingle extends GroupWaveSharedSingle {
  program_admins: Admin[];
  _differs: {[field: string]: boolean};
  _release_differs: {[fm_id: string]: boolean}
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/models/program/wave-single.ts